import type { TedIntonationSpan } from '@/types/screenplay';
import { savedDeliveryDirection } from './geminiDelivery';
import { titleTedEmotion } from './tedIntonation';

export interface PerformanceAttribute { type: string; value: string }

/** Display metadata only: labels never enter the screenplay or speech payload. */
export function performanceAttributes(span: TedIntonationSpan): PerformanceAttribute[] {
  const d=savedDeliveryDirection(span);
  if(!d)return [];
  const result:PerformanceAttribute[]=[];
  const add=(type:string,value?:string)=>{if(value?.trim())result.push({type,value:value.trim()});};
  add('Emotion',d.emotion);
  add('Subtle emotion',d.subtle);
  add('Attitude',d.attitude);
  add('Delivery',d.delivery);
  add('Delivery strength',d.delivery?d.deliveryStrength:undefined);
  add('Volume',d.volume || (span.volumeDb?`${span.volumeDb>0?'+':''}${span.volumeDb} dB`:undefined));
  add('Playback volume',d.audioGainDb!==undefined?`${d.audioGainDb>0?'+':''}${d.audioGainDb} dB`:undefined);
  add('Volume progression',d.volumeMotion);
  add('Speed',d.pace);
  add('Recording speed',d.audioSpeed!==undefined?`${d.audioSpeed.toFixed(2)}× (pitch preserved)`:undefined);
  add('Pitch',d.pitch || (span.pitchSemitones?`${span.pitchSemitones>0?'+':''}${span.pitchSemitones} semitones`:undefined));
  add('Emotional intensity',d.intensity || (!span.gemini&&span.emotionStrength!==1?String(span.emotionStrength):undefined));
  add('Custom direction',d.custom);
  add('Vocal cue',d.cue);
  const pause=d.pauseMs || span.pauseBeforeMs;
  add('Pause',pause?`${pause/1000} seconds`:undefined);
  add('Text',d.unspoken?'Not spoken':undefined);
  if(!span.gemini&&!result.some(a=>a.type==='Emotion'))add('Emotion',titleTedEmotion(span.emotion));
  return result;
}
